class VolumeWeightRatio {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

export const CODE_NAME = 'volumeWeightRatio'
const KGS1000 = new VolumeWeightRatio(1000, '1000KGS/CBM')
const KGS500 = new VolumeWeightRatio(500, '500KGS/CBM')
const KGS363 = new VolumeWeightRatio(363, '363KGS/CBM')
const KGS333 = new VolumeWeightRatio(333, '333KGS/CBM')
const KGS300 = new VolumeWeightRatio(300, '300KGS/CBM')
export const KGS_TYPES = [
  KGS1000,
  KGS500,
  KGS363,
  KGS333,
  KGS300
]
/**
 * return null:没找到.
 */
export function getVolumeWeightRatioCode(code) {
  return KGS_TYPES.find(el => el.code === code)
}
